import { ListItemButton, ListItemText } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { useLocation, useNavigate } from "react-router-dom";

const NavCloseDrawer = ({ to, primary, chiudiMenu, accent = "#D47200" }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const active = location.pathname === to;

  const clickBottone = () => {
    chiudiMenu();
    navigate(to);
  };

  return (
    <ListItemButton
      onClick={clickBottone}
      sx={{
        mx: 1,
        my: 0.25,
        minHeight: 38,
        borderRadius: 2,
        border: "1px solid transparent",
        color: active ? accent : "text.primary",
        backgroundColor: active ? alpha(accent, 0.14) : "transparent",
        "&:hover": {
          borderColor: alpha(accent, 0.28),
          backgroundColor: alpha(accent, active ? 0.18 : 0.08),
        },
        "& .MuiListItemText-primary": {
          fontSize: 14,
          fontWeight: active ? 900 : 650,
        },
      }}
    >
      <ListItemText primary={primary} />
    </ListItemButton>
  );
}

export default NavCloseDrawer;
